module.exports = __webpack_public_path__ + "static/media/sony-wf-1000mx3.a7552398.jpg";